app.service('PatientCareTeamAPI', 
	[
		'$http', 
		'ENV', 
		'Session', 
	function(
		$http, 
		ENV, 
		Session
	) {
		var service = {
			isProcessing: false,

			queryPatientCareTeam: function (patientId) {
				return $http({
					method: "GET",
					url: ENV.API + `/api/patient-careteam/${patientId}`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					}
				});
			},
			createCareTeam: function(patientId, newCareTeam) {
				return $http({
					method: "POST",
					url: ENV.API + `/api/patient-careteam/${patientId}`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
					data: newCareTeam
				});
			},
			deleteCareTeam: function(patientId, careTeamId) {
				return $http({
					method: "DELETE",
					url: ENV.API + `/api/patient-careteam/${patientId}/careteam/${careTeamId}`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
				});
			},
			// searchPracticeById: function(id) {
			// 	return $http({
			// 		method: "GET",
			// 		url: ENV.API + `/api/practices/search?searchTerm=${searchTerm}`,
			// 		headers: {
			// 			Authorization: "Bearer " + Session.token,
			// 			"X-PRACTICE-ID": `${Session.practice.id}`,
			// 		},
			// 	});
			// },
		};

		return service;
	}]
)
